import React from 'react';
export const CloseIcon = ({
  size = 16
}: {
  size?: number;
}) => {
  return <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="CloseIcon" data-sentry-source-file="CloseIcon.tsx">
      <path d="M12.6673 4.27337L11.7273 3.33337L8.00065 7.06004L4.27398 3.33337L3.33398 4.27337L7.06065 8.00004L3.33398 11.7267L4.27398 12.6667L8.00065 8.94004L11.7273 12.6667L12.6673 11.7267L8.94065 8.00004L12.6673 4.27337Z" fill="#696F88" data-sentry-element="path" data-sentry-source-file="CloseIcon.tsx" />
    </svg>;
};